export const StorageConstants = {
    JWTToken: 'jwtToken',
    AccessToken: "accessToken"
}